import styled from 'styled-components';
import { DefaultText } from '../../../styles/global/css/GlobalText';
import { BorderColor, PrimaryColor } from '../../../styles/global/css/Utils';
import { BodyMainContainer } from './PopupStyle';

const Span = styled.span<{ noClick?: boolean }>`
  ${p =>
		p.noClick
			? ''
			: `
        color: ${PrimaryColor};
        cursor: pointer;

        &:hover {
            text-decoration: underline;
        }
    `}
  font-weight: 600;
  display: block;
  overflow-x: hidden;
  text-overflow: ellipsis;
  margin-left: 3px;
`;

const TimelineBodyMainContainer = styled(BodyMainContainer)`
  width: 100%;
  padding-left: 20px;
  height: calc(100% - 80px);
  display: flex;
  flex-direction: column;
  gap: 30px;
`;

const TimelineGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

const TimelineContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: calc(100% - 52px);
`;

interface TimelineHeaderProps {
	isOpen: boolean;
}

const TimelineHeader = styled.div<TimelineHeaderProps>`
  transition: all 0.4s ease;
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 0 20px 10px 20px;
  min-height: 80px;
  opacity: ${p => (p.isOpen ? '1' : '0')};
  justify-content: end;
`;

const TimelineHeaderLine = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  gap: 15px;
  width: 100%;
  padding: 0 0 15px 0;
`;

const TimelineDate = styled.p`
  ${DefaultText}
  font-weight: 500;
  font-size: 13px;
`;

interface TimelineCollapseProps {
	isOpen: boolean;
}

const TimelineCollapse = styled.div<TimelineCollapseProps>`
  display: ${p => (p.isOpen ? 'flex' : 'none')};
  flex-direction: column;
  gap: 15px;
  position: relative;
  z-index: 0;

  &::before {
    content: '';
    position: absolute;
    z-index: -1;
    left: 13px;
    top: 25px;
    bottom: 25px;
    width: 4px;
    background-color: ${BorderColor};
  }
`;

export {
	Span,
	TimelineBodyMainContainer,
	TimelineCollapse,
	TimelineContainer,
	TimelineDate,
	TimelineGroup,
	TimelineHeader,
	TimelineHeaderLine
};
